// src/components/contact/AddressCard.jsx
import React from "react";

const MEDIA_ORIGIN = (import.meta.env.VITE_API_BASE_URL || "").replace(
  /\/api\/?$/,
  ""
);

export const getAddressCardUrl = (card) => {
  if (!card?.url) return null;
  return resolveImageUrl(card.url);
};

const resolveImageUrl = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  const path = url.startsWith("/") ? url : `/${url}`;
  return MEDIA_ORIGIN ? `${MEDIA_ORIGIN}${path}` : path;
};

const AddressCard = ({ card, delay = 0 }) => {
  const imageUrl = getAddressCardUrl(card);
  const alt = card?.alternativeText || card?.name || "Contact address";

  if (!imageUrl) return null;

  return (
    <div className="relative h-auto w-full">
      <img
        src={imageUrl}
        alt={alt}
        className="block h-auto w-full object-contain animate-slide-in-left"
        style={{ animationDelay: `${delay}ms` }}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
};

export default AddressCard;
